module.exports = __webpack_public_path__ + "2568b9b327df6838a4b6a9ba6e592686.jpg";